__turbopack_context__.v({
  "card": "ParagraphServiceHero-module__BSLsJa__card",
  "cardAuthor": "ParagraphServiceHero-module__BSLsJa__cardAuthor",
  "cardAuthorName": "ParagraphServiceHero-module__BSLsJa__cardAuthorName",
  "cardAuthorRole": "ParagraphServiceHero-module__BSLsJa__cardAuthorRole",
  "cardBg": "ParagraphServiceHero-module__BSLsJa__cardBg",
  "cardContact": "ParagraphServiceHero-module__BSLsJa__cardContact",
  "cardContactIcon": "ParagraphServiceHero-module__BSLsJa__cardContactIcon",
  "cardContactLabel": "ParagraphServiceHero-module__BSLsJa__cardContactLabel",
  "cardContactPhone": "ParagraphServiceHero-module__BSLsJa__cardContactPhone",
  "cardContactText": "ParagraphServiceHero-module__BSLsJa__cardContactText",
  "cardCta": "ParagraphServiceHero-module__BSLsJa__cardCta",
  "cardInner": "ParagraphServiceHero-module__BSLsJa__cardInner",
  "cardPhoto": "ParagraphServiceHero-module__BSLsJa__cardPhoto",
  "cardPhotoOverlay": "ParagraphServiceHero-module__BSLsJa__cardPhotoOverlay",
  "cardTitle": "ParagraphServiceHero-module__BSLsJa__cardTitle",
  "content": "ParagraphServiceHero-module__BSLsJa__content",
  "eyebrow": "ParagraphServiceHero-module__BSLsJa__eyebrow",
  "lead": "ParagraphServiceHero-module__BSLsJa__lead",
  "logoImg": "ParagraphServiceHero-module__BSLsJa__logoImg",
  "logoTile": "ParagraphServiceHero-module__BSLsJa__logoTile",
  "logosRow": "ParagraphServiceHero-module__BSLsJa__logosRow",
  "section": "ParagraphServiceHero-module__BSLsJa__section",
  "title": "ParagraphServiceHero-module__BSLsJa__title",
  "trustedBy": "ParagraphServiceHero-module__BSLsJa__trustedBy",
  "trustedHeading": "ParagraphServiceHero-module__BSLsJa__trustedHeading",
});
